import { render, staticRenderFns } from "./WEBMULTI.vue?vue&type=template&id=5880ada9"
import script from "./WEBMULTI.vue?vue&type=script&lang=js"
export * from "./WEBMULTI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports